import { BoxComponent, TypographyComponent } from '@zeus/web-components';
import { styles } from './cartItem.styles';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { IconButton, useMediaQuery } from '@mui/material';
import theme from '../../theme/Theme';

const colors = {
  warning: 'warning.main',
};
const WarningBar = ({
  text,
  color,
  handleDelete,
}: {
  text: string;
  color: 'warning';
  handleDelete?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<void>;
}) => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <BoxComponent
      sx={{
        ...styles.topContainer,
        height: isSmallScreen ? '30px' : isMediumScreen ? '35px' : '40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      id="cart-item__warning-bar"
    >
      <TypographyComponent sx={{ ...styles.topContainerLabel, fontWeight: 400 }}>
        <WarningAmberOutlinedIcon sx={{ color: colors[color], marginRight: '10px' }} fontSize="medium" />
        {text}
      </TypographyComponent>
      {handleDelete && (
        <IconButton
          id="cart-items__delete-button"
          onClick={handleDelete}
          sx={{
            padding: '4px 8px',
            display: 'flex',
            gap: '4px',
            color: '#D32F2F',
            fontSize: '14px',
            fontWeight: 500,
            fontFamily: 'Poppins, sans-serif',
            '&:hover': {
              backgroundColor: 'rgba(211, 47, 47, 0.04)',
            },
          }}
        >
          <span>Remove</span>
        </IconButton>
      )}
    </BoxComponent>
  );
};

export default WarningBar;
